export enum UserMembershipStatus {
    New = 1,
    Current = 2,
    Grace = 3,
    Delinquent = 9,
    CoopPending = 10,
}

export const ActiveUserMembershipStatuses = [
    UserMembershipStatus.New,
    UserMembershipStatus.Current,
    UserMembershipStatus.Grace,
];

export const UserMembershipStatusActiveLabels = {
    active: 'Active',
    grace: 'Grace',
    inactive: 'No',
};

export const UserMembershipStatusLabelMapping: Record<
    UserMembershipStatus,
    string
> = {
    [UserMembershipStatus.New]: UserMembershipStatusActiveLabels.active,
    [UserMembershipStatus.Current]: UserMembershipStatusActiveLabels.active,
    [UserMembershipStatus.Grace]: UserMembershipStatusActiveLabels.grace,
    [UserMembershipStatus.Delinquent]:
        UserMembershipStatusActiveLabels.inactive,
    [UserMembershipStatus.CoopPending]:
        UserMembershipStatusActiveLabels.inactive,
};
